import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Breadcrumb from '../components/Breadcrumb';
import HeroSectionSecondary from '../components/HeroSectionSecondary';
import ChrisNote from '../components/ChrisNote';
import '../styles/maintenance.css';
import CTASection from '../components/CTASection';
import IntegratedPropertySolutionsSection from '../components/IntegratedPropertySolutionsSection';
import AspireSection from '../components/AspireSection';

const Maintenance = () => {
  // State for each season's expanded status
  const [showMoreSpring, setShowMoreSpring] = useState(false);
  const [showMoreSummer, setShowMoreSummer] = useState(false);
  const [showMoreFall, setShowMoreFall] = useState(false);
  const [showMoreWinter, setShowMoreWinter] = useState(false);

  return (
    <div className="maintenance-page">
      <Navbar />
      <Breadcrumb />
      
      <div className="hero-maintenance">
        <HeroSectionSecondary
          title="Professional Maintenance"
          subtitle="Complete outdoor management for residential properties and commercial clients"
          button1Text="Request A Consultation"
          button1Link="mailto:info@allseasons.info"
          target="_blank"
          rel="noopener noreferrer"
          button2Text="Gallery"
          button2Link="/gallery"
          image="/images/maintenance/HEROmaintenance1.jpeg"
        />
      </div>

        {/* Note from Chris Section */}
      <ChrisNote />

      {/* One Call Banner */}
      <div className="everything-cta-banner">
        <div className="cta-container">
          <div className="cta-inner">
            <h3>One Call. All Seasons. Problem Solved.</h3>
            <p>While other companies give you a list of what they can't do, we figure out how to get it done. From routine maintenance to emergency response, from sustainable design to snow on the roof - if it's outside your building, it's our responsibility.</p>
          </div>
        </div>
      </div>

      {/* Our Work Showcase */}
      <section className="property-showcase">
        <div className="section-inner">
          <div className="showcase-grid">
            <div className="showcase-image showcase-image--main">
              <img src="/images/maintenance/2people.JPG" alt="Commercial property maintenance" />
              <div className="image-label">
                <span className="label-number">01</span>
                <span className="label-text">COMMERCIAL PROPERTIES</span>
              </div>
            </div>
            <div className="showcase-image showcase-image--secondary">
              <img src="/images/maintenance/hoaLand.JPG" alt="HOA landscaping" />
              <div className="image-label">
                <span className="label-number">02</span>
                <span className="label-text">HOA LANDSCAPES</span>
              </div>
            </div>
            <div className="showcase-image showcase-image--accent">
              <img src="/images/snow/snowPlow.jpg" alt="Snow management" />
              <div className="image-label">
                <span className="label-number">03</span>
                <span className="label-text">EMERGENCY RESPONSE</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Property Management Section */}
      <section className="section bg-white">
        <div className="section-inner">
          <h2 className="section-title text-center">Complete Property Management Solutions</h2>
          <p className="section-subtitle text-center">Managing properties means juggling a lot at once. We're here to make landscape care the easiest part of your job.</p>
        </div>
      </section>
      <IntegratedPropertySolutionsSection
        layout="compact"
        ctaOverride={{
          link: "mailto:info@allseasons.info",
          text: "Request Consultation"
        }}
      />

 {/* Year-Round Services - 2x2 Grid */}
      <section className="seasonal-services-visual">
        <div className="seasonal-container">
          <div className="seasonal-header">
            <h2>Year-Round Service Programs</h2>
            <p>Customizable maintenance packages for residential properties and commercial clients</p>
          </div>

          <div className="seasonal-compact-grid">
            <div className="season-card-compact spring">
              <div className="season-image">
                <img src="/images/flower/flowerPurpleRed1.jpg" alt="Spring services - flower planting" />
              </div>
              <div className="season-content">
                <h3>Spring Services</h3>
                <p className="season-months">March – May</p>
                <div className="services-preview">
                  <ul>
                    <li>Spring clean-up (branches, debris, winter damage)</li>
                    <li>Irrigation system activation and tuning</li>
                    <li>Soil aeration and fertilization</li>
                    <li>Bed cultivation and edge refresh</li>
                    <li>Lawn de-thatching (if applicable)</li>
                  </ul>
                </div>
                <button className="expand-services-btn" onClick={() => setShowMoreSpring(!showMoreSpring)}>
                  {showMoreSpring ? 'View Less' : 'View More'}
                </button>
                
                <div className={`services-detailed ${showMoreSpring ? 'expanded' : ''}`}>
                  <div className="service-category">
                    <h4>Additional Standard Services</h4>
                    <ul>
                      <li>Early weed and pest management</li>
                      <li>Seasonal flower installation</li>
                      <li>Inspection of drainage systems</li>
                    </ul>
                  </div>
                  <div className="service-category">
                    <h4>Optional Add-ons</h4>
                    <ul>
                      <li>Mulch replenishment</li>
                      <li>Pressure washing patios/walkways</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="season-card-compact summer">
              <div className="season-image">
                <img src="/images/flower/flowerSummer.JPG" alt="Summer maintenance services" />
              </div>
              <div className="season-content">
                <h3>Summer Services</h3>
                <p className="season-months">June – August</p>
                <div className="services-preview">
                  <ul>
                    <li>Weekly landscape maintenance (mowing, edging, pruning)</li>
                    <li>Turf and plant health monitoring</li>
                    <li>Ongoing irrigation audits and adjustments</li>
                    <li>Weed, pest, and disease control</li>
                    <li>Mid-season fertilization</li>
                  </ul>
                </div>
                <button className="expand-services-btn" onClick={() => setShowMoreSummer(!showMoreSummer)}>
                  {showMoreSummer ? 'View Less' : 'View More'}
                </button>
                
                <div className={`services-detailed ${showMoreSummer ? 'expanded' : ''}`}>
                  <div className="service-category">
                    <h4>Additional Standard Services</h4>
                    <ul>
                      <li>Flower and bed care</li>
                      <li>Tree and shrub maintenance</li>
                    </ul>
                  </div>
                  <div className="service-category">
                    <h4>Optional Add-ons</h4>
                    <ul>
                      <li>Seasonal flower refresh (midsummer)</li>
                      <li>Pond or water feature maintenance</li>
                      <li>Outdoor lighting checks</li>
                      <li>Storm debris clean-up</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="season-card-compact fall">
              <div className="season-image">
                <img src="/images/tree/treeHeroImage3.jpg" alt="Fall tree and leaf management" />
              </div>
              <div className="season-content">
                <h3>Fall Services</h3>
                <p className="season-months">September – November</p>
                <div className="services-preview">
                  <ul>
                    <li>Fall cleanup (leaf removal, pruning, garden bed clearing)</li>
                    <li>Irrigation system winterization/blowout</li>
                    <li>Fertilization for winter hardiness</li>
                    <li>Tree/shrub trimming for structure and health</li>
                    <li>Hardscape inspection (pavers, walkways)</li>
                  </ul>
                </div>
                <button className="expand-services-btn" onClick={() => setShowMoreFall(!showMoreFall)}>
                  {showMoreFall ? 'View Less' : 'View More'}
                </button>
                
                <div className={`services-detailed ${showMoreFall ? 'expanded' : ''}`}>
                  <div className="service-category">
                    <h4>Optional Add-ons</h4>
                    <ul>
                      <li>Protective wraps for vulnerable plants</li>
                      <li>Drainage inspection and grading adjustments</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="season-card-compact winter">
              <div className="season-image">
                <img src="/images/projects/sageDemoDriveProject1.jpeg" alt="Winter snow and ice management" />
              </div>
              <div className="season-content">
                <h3>Winter Services</h3>
                <p className="season-months">December – February</p>
                <div className="services-preview">
                  <ul>
                    <li>Snow plowing for driveways and access roads</li>
                    <li>Snow shoveling/Hand clearing</li>
                    <li>Roof snow/ice clearing (if contracted)</li>
                    <li>Ice melt application (eco-safe options available)</li>
                    <li>Emergency storm response</li>
                    <li>Holiday Lighting</li>
                  </ul>
                </div>
                <button className="expand-services-btn" onClick={() => setShowMoreWinter(!showMoreWinter)}>
                  {showMoreWinter ? 'View Less' : 'View More'}
                </button>
                
                <div className={`services-detailed ${showMoreWinter ? 'expanded' : ''}`}>
                  <div className="service-category">
                    <h4>Optional Add-ons</h4>
                    <ul>
                      <li>Post-storm property inspections</li>
                      <li>Heated surface inspection & maintenance</li>
                      <li>Holiday lighting installation/removal</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Highlighted Services */}
      <section className="highlighted-services">
        <div className="highlighted-container">
          <div className="highlighted-header">
            <h2>Highlighted Services</h2>
            <p>The essential maintenance services keep your landscape thriving year-round</p>
          </div>

          <div className="highlighted-services-grid">
            <div className="highlighted-service-card">
              <div className="service-image">
                <img src="/images/maintenance/mowingBig1.jpg" alt="Professional landscaping services" />
              </div>
              <div className="service-content">
                <h3>Landscaping</h3>
                <ul>
                  <li>Weekly mowing and edging</li>
                  <li>Professional pruning and trimming</li>
                  <li>Bed health monitoring and care</li>
                  <li>Weed control and removal</li>
                  <li>Seasonal cleanup services</li>
                  <li>Mulching and bed maintenance</li>
                </ul>
                <div className="service-warranty">
                  <p><strong>Ask about our landscaping warranties</strong></p>
                </div>
              </div>
            </div>

            <div className="highlighted-service-card">
              <div className="service-image">
                <img src="/images/maintenance/spray2.jpeg" alt="Professional spraying and fertilization" />
              </div>
              <div className="service-content">
                <h3>Spraying Programs</h3>
                <ul>
                  <li>Fertilizer applications</li>
                  <li>Integrated pest management</li>
                  <li>Disease prevention and treatment</li>
                  <li>Selective herbicide applications</li>
                  <li>Eco-conscious options</li>
                  <li>Soil health improvement</li>
                </ul>
                <div className="service-warranty">
                  <p><strong>Guaranteed results with warranty protection</strong></p>
                </div>
              </div>
            </div>

            <div className="highlighted-service-card">
              <div className="service-image">
                <img src="/images/water/creekPretty1.jpg" alt="Irrigation system management" />
              </div>
              <div className="service-content">
                <h3>Irrigation Management</h3>
                <ul>
                  <li>System design and installation</li>
                  <li>Seasonal activation and winterization</li>
                  <li>Smart controller upgrading</li>
                  <li>Troubleshooting and repair</li>
                  <li>Water efficiency optimization</li>
                  <li>Large Scale Pumping Systems</li>
                </ul>
                <div className="service-warranty">
                  <p><strong>Installation and repair warranties available</strong></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Aspire Platform Section */}
      <section className="section bg-white">
        <div className="section-inner">
          <h2 className="section-title text-center">Aspire Platform</h2>
          <p className="section-subtitle text-center">Real-time updates, schedules, and photos for property managers</p>
        </div>
      </section>
      <AspireSection
        showLogos={false}
        layout="split"
        quoteHighlight={true}
        showCTA={true}
        ctaText="Access Your Property Dashboard"
        ctaLink="https://allseasons.propertyserviceportal.com/"
      />

      {/* Hero Image Section */}
      <section className="hero-feature-section">
        <div className="hero-feature-container">
          <div className="hero-image-container">
            <img src="/images/maintenance/watertreeslawnshrub1.jpg" alt="Beautiful water feature with naturalistic landscaping" />
            <div className="image-overlay">
              <h3>Water • Lawn • Trees• Shrubs</h3>
              <p>We maintain every element of your outdoor space</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <CTASection
        title="Ready for Worry-Free Maintenance?"
        subtitle="Join hundreds of satisfied customers who trust All Seasons with complete outdoor management"
        galleryLink="/Gallery/maintenance"
        showEmergency={true}
      />
    </div>
  );
};

export default Maintenance;